// routes/_app.video.$idSlug.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/_app.video.$idSlug')

export const handle = {
  name: 'video-artwork-detail',
  track: { scene: 'artwork-detail' },
  showAppNav: true,
}

export default dynamic(getClientModule, { ssr: false })
